import styles from './Badge.module.scss';

type BadgeProps = {
  type?: 'danger' | 'attention';
  shape?: 'rectangle' | 'rounded';
  size?: 'regular' | 'small';
};

const Badge: React.FC<React.PropsWithChildren<BadgeProps>> = ({
  children,
  type = 'attention',
  shape = 'rounded',
  size = 'regular',
}) => {
  return (
    <div className={styles['badge']} data-type={type} data-shape={shape} data-size={size}>
      {children}
    </div>
  );
};

export default Badge;
